import HeaderOther from "./header-other";

export default function AboutUs() {
    return (
        <>
            <HeaderOther />
            <div style={{margin:'10px'}}>
                <p style={{ fontSize: '24px', textAlign: 'center', fontWeight: '500', marginTop:'20px', marginBottom:'0px' }}>About Us</p>
                <img src="/ontimeurban-logo.png" alt="ontimeurban logo" style={{width:'100%'}} />
                <div style={{backgroundColor:'whitesmoke', borderRadius:'10px', padding:'10px'}}>
                    <p style={{fontSize:'14px', marginTop:'0px'}}>
                        Welcome to OnTimeUrban, your trusted partner for instant and hassle-free shopping.
                        We are proud to serve the vibrant community of Hazaribagh, Jharkhand, with a mission
                        to deliver quality products to your doorstep in just 15 minutes.
                    </p>
                    <p style={{fontSize:'14px'}}>
                        At OnTimeUrban, we specialize in a wide range of products, including groceries, daily essentials,
                        gadgets, and more. Our goal is to bring convenience and value to your life, offering a seamless shopping
                        experience that saves you time and effort.
                    </p>
                    <p style={{ fontSize: '16px', fontWeight:'500' }}>Why Choose Us?</p>
                    <ul style={{ fontSize: '14px' }}>
                        <li><span style={{ fontWeight: '500' }}>Lightning-Fast Delivery:</span> Your essentials, delivered in 15 minutes.</li>
                        <li><span style={{ fontWeight: '500' }}>Quality Assurance:</span> We handpick the best products to ensure customer satisfaction.</li>
                        <li><span style={{ fontWeight: '500' }}>Affordable Pricing:</span> Great deals and competitive prices for all your needs.</li>
                        <li><span style={{ fontWeight: '500' }}>Local Expertise:</span> Serving the unique needs of Hazaribagh with care and dedication.</li>
                    </ul>
                    <p style={{ fontSize: '14px' }}>
                        We are committed to empowering local communities and making everyday life easier for students, families,
                        and professionals alike. At OnTimeUrban, we believe in innovation, efficiency, and customer-first service.
                    </p>
                    <p style={{ fontSize: '20px', fontWeight: '500', textAlign: 'center' }}>Find us on: </p>
                    <div style={{display:'flex', flexDirection:'row', justifyContent:'space-evenly', maxWidth:'600px'}}>
                        <a target="blank" href="https://instagram.com/on_time_urban"><img src="/icons/instagram.png" alt="Instagram" style={{width:'35px', height:'35px'}}/></a>
                        <a target="blank" href="https://x.com/ontimeurban"><img src="/icons/twitter.png" alt="Twitter" style={{width:'35px', height:'35px'}}/></a>
                        <a target="blank" href="https://www.facebook.com/people/OnTime-Urban/pfbid02cdCC7t25F2NL79x5Da9tN1TTLkjxWDyizAxnJeRVVDQ3pZpxcDB9mgVZq61KiGyUl/"><img src="/icons/facebook.png" alt="Facebook"style={{width:'35px', height:'35px'}}/></a>
                        <a href="#"><img src="/icons/youtube.png" alt="Youtube"style={{width:'35px', height:'35px'}}/></a>
                    </div>
                </div>
            </div>
        </>
    );
}